import { OrgAdminScreenProps } from "./OrgAdmin";
import { LazyQueryNetworkBoundrary } from "../../../components/mobile/QueryNetworkBoundrary";
import React from "react";
import { Box } from "arkh";
import { OrgButton } from "../OrgButton";

export function OrgAdminDeveloperScreen(
  props: OrgAdminScreenProps<"OrgAdminDeveloper">
) {
  return (
    <LazyQueryNetworkBoundrary newFetchKeyOnNavigation>
      {(fetchKey: string) => (
        <InnerOrgAdminDeveloperScreen {...props} fetchKey={fetchKey} />
      )}
    </LazyQueryNetworkBoundrary>
  );
}

function InnerOrgAdminDeveloperScreen(
  props: OrgAdminScreenProps<"OrgAdminDeveloper"> & { fetchKey: string }
) {
  return (
    <Box
      spaceTop="medium"
      spaceHorizontal="medium"
      color="surface-background-light"
    >
      <Box
        color="surface-primary"
        space="medium"
        cornerRadius="large"
        style={{
          flex: 1,
          flexDirection: "row",
        }}
      >
        <OrgButton
          tintColor="text-inverted"
          backgroundColor="primary"
          title="Product API Playground"
          onPress={() => {
            props.navigation.navigateDeprecated("ProductAPIPlayground", {});
          }}
        />
      </Box>
    </Box>
  );
}
